var breakpoint_mobile = 1023;

import dropdownLi from './blocks/dropdown-li.js';
import helpers from './helpers';

dropdownLi();

(function (){
    if ( navigator.userAgent.match(/iPad/i) != null ||
        navigator.userAgent.match(/iPhone/i) != null ||
        navigator.userAgent.match(/iPod/i) != null ) {
        $('body').addClass('hh-apple-device');
    }
})();

/**
 * Адаптивность таблиц в контенте статей
 */
(function ($){
    var wrapper_class = 'hh-table-wrapper';
    var $tables = $('.hh-post-content').find('table');

    $tables.each(function (index, element) {
        var $table = $(element);
        var $parent = $table.parent();

        if ($parent.hasClass('hh-post-content')) {
            $table.wrap('<div class="' + wrapper_class + '"></div>')
        } else {
            $parent.addClass(wrapper_class);
        }
    });
})(jQuery);

// Скрипт для открытия дополнительного окна (например, для меню)
$(document).ready(() => {

    // Биндим ссылки для открытия окна
    $('.js-overlay__link').on('click', event => {
        const overlayContainer = $('#' + $(event.currentTarget).attr('data-target'));

        overlayContainer.fadeIn(300);
        $(overlayContainer).trigger('hh:overlay:is_showed');
    });

    // Биндим кнопки закрытия окна
    /*$('.js-overlay__close').each((index, element) => {

    });*/
    $('.js-overlay__close').on('click', event => {
        const overlayContainer = $(event.currentTarget).parents('.js-overlay__container');

        overlayContainer.fadeOut(300);
    });
});

/**
 * Скрытие показ главного меню (мобильная версия)
 */
jQuery(document).ready(function($) {
    var $button = $('.js-main-mobile-menu__button');
    var $content = $('.js-main-mobile-menu__content');

    $button.click(function () {
        $button.toggleClass('main-mobile-menu__button--open');
        $content.toggle();
    });
});


/**
 * JS скрипт подгрузки статей и блоков (Другие материалы, Лучшие материалы)
 *
 * @author <renakdup@gmail.com>
 */
function hh_load_more_posts( args ) {
    var paged = 2;
    var lock_button = false; // Используется для блокировки кнопки пока не получим server response
    var response = {};

    if( args.buttonSelector === undefined || args.selectors === undefined || args.requestUrl === undefined ) {
        console.error( 'Object "args" function hh_load_more_posts() must contain next properties: buttonSelector, selectors, requestUrl' );
        console.error( 'Object "args"', args );
        return;
    }

    $( args.buttonSelector ).on( 'click', function () {
        viewSpinner(true);

        if( lock_button === true ) {
            return;
        }

        lock_button = true;

        // hook для изменения args атрибутов
        args = handlerData( args, response );

        $.ajax( {
            type: "GET",
            url: args.requestUrl,
            data: args.data,
            success: function ( response_ajax ) {
                viewSpinner(false);
                lock_button = false;

                if( !response_ajax instanceof Object ) {
                    hideButton();
                    return;
                }

                if( isEmptyObj( response_ajax ) ) {
                    hideButton();
                    return;
                }

                if( response_ajax.max_num_pages === paged ) {
                    hideButton();
                }

                paged++;
                response = response_ajax;

                appendData( response_ajax.data );
                $(document).trigger('hh:archive:page_load');
            }
        } );
    } );


    /**
     * Хук для обработки/изменения data объекта
     *
     * @param data
     * @returns {*|{}|{vacant_post_number: *}}
     */
    function handlerData( args, response ) {
        args.data.paged = paged;

        if( !args.handlerData ) {
            return args;
        }

        return args.handlerData( args, response );
    }

    // Отображаем/скрываем спиннер в кнопке
    function viewSpinner( visibility ) {
        var text_button_selector = '.js-load-more-text';
        var spinner_button_selector = '.js-load-more-spinner';

        if( visibility === true ) {
            $( args.buttonSelector ).attr('disabled', 'true');
            $( args.buttonSelector ).children(text_button_selector).css( { opacity: 0 } );
            $( args.buttonSelector ).children(spinner_button_selector).show();
            return;
        }

        $( args.buttonSelector ).removeAttr('disabled');
        $( args.buttonSelector ).children(text_button_selector).css( { opacity: 1 } );
        $( args.buttonSelector ).children(spinner_button_selector).hide();

        return;
    }

    function isEmptyObj( obj ) {
        for( var key in obj ) {
            return false;
        }
        return true;
    }

    function hideButton() {
        $( args.buttonSelector ).hide();
    }

    function appendData( data ) {
        if( typeof data !== 'object' || typeof args.selectors !== 'object') {
            console.error( '"response.data" and "selectors" both must be are arrays', response.data );
        }

        // Ключ переданных данных с сервера должен соотвествовать ключу селектора
        for (let key in args.selectors) {
            if( !data[ key ] ) {
                console.error( 'Object \'data\' haven\'t key: ' + key );
                continue;
            }

            $( args.selectors[ key ] ).append( data[ key ] );
        }
    }
}



/**
 * Подгрузка блока "Лучшие материалы" внизу статьи
 */
jQuery( document ).ready( function () {
    if( !HH.rest_route__best_materials_load_more ) {
        return;
    }

    var args = {
        buttonSelector: '.js-hh-load-more__best_materials__button',
        selectors: {
            content: '.js-hh-load-more__best_materials__content',
        },
        requestUrl: HH.rest_route__best_materials_load_more,
        data: {
            current_post: HH.rest_data__current_post, //exclude post
        },
    }

    hh_load_more_posts(args);
} );


/**
 * Подгрузка блока "Другие фотоленты" внизу страницы фотолента
 */
jQuery( document ).ready( function () {
    if( !HH.rest_route__other_phototape__load_more ) {
        return;
    }

    var args = {
        buttonSelector: '.js-hh-load-more__other_phototape__button',
        selectors: {
            content: '.js-hh-load-more__other_phototape__content',
        },
        requestUrl: HH.rest_route__other_phototape__load_more,
        data: {
            current_post: HH.rest_data__current_post, //exclude post
        },
    }

    hh_load_more_posts(args);
} );


/**
 * Подгрузка записей в "Архиве вопросов специалистам"
 */
jQuery( document ).ready( function () {
    if( !HH.rest_route__archive_question_to_expert__load_more ) {
        return;
    }

    var args = {
        buttonSelector: '.js-load-more__archive-question-to-expert__button',
        selectors: {
            content: '.js-load-more__archive-question-to-expert__content',
        },
        requestUrl: HH.rest_route__archive_question_to_expert__load_more,
        data: {},
    }

    hh_load_more_posts(args);
} );


/**
 * Подгрузка постов в категориях (кроме исключеннх в ArchiveMainLayout)
 *
 * @author  <renakdup@gmail.com>
 */
jQuery( document ).ready( function () {
    if( !HH.rest_route__archive_main_layout__load_more ) {
        return;
    }

    var args = {
        buttonSelector: '.js-load-more__archive-main-layout__button',
        selectors: {
            list: '.js-load-more__archive-list-main-layout__content',
            tile: '.js-load-more__archive-tile-main-layout__content',
        },
        requestUrl: HH.rest_route__archive_main_layout__load_more,
        data: {
            current_category: HH.rest_data__current_category,
            vacant_post_number: HH.rest_data__vacant_post_number,
        },
        // Получаем "Вакантные посты" с сервера и отправляем их в data при следующем запросе
        handlerData: function ( args, response ) {

            if (response.vacant_post_number !== undefined) {
                args.data.vacant_post_number = response.vacant_post_number;
            }

            return args;
        }
    }

    hh_load_more_posts(args);
} );


// Archive layout switch active button
const set_active_switch_layout_button = () => {
    const tile_switch_button = $('.js-hh-category-layout-switch__tile');
    const line_switch_button = $('.js-hh-category-layout-switch__line');
    const active_class = 'hh-category__switch-button--active';

    const current_layout = localStorage.getItem('hh-archive-layout') !== null ? localStorage.getItem('hh-archive-layout') : 'tile-template';

    if (current_layout === 'line-template') {
        line_switch_button.addClass(active_class);
        tile_switch_button.removeClass(active_class);
    }
    else {
        tile_switch_button.addClass(active_class);
        line_switch_button.removeClass(active_class);
    }
};

jQuery(document).ready(function($) {
    const line_template = $('.hh-archive-main-layout__line-template');
    const tile_template = $('.hh-archive-main-layout__tile-template');
    set_active_switch_layout_button();

    $('.js-hh-category-layout-switch ').each(function(index, element) {
        $(element).click(() => {
            const layout_click = $(element).attr('data-layout-name');

            switch (layout_click) {
                case 'tile':
                    line_template.hide();
                    tile_template.show();

                    localStorage.setItem('hh-archive-layout', 'tile-template');
                    set_active_switch_layout_button();
                    break;

                case 'line':
                    line_template.show();
                    tile_template.hide();

                    localStorage.setItem('hh-archive-layout', 'line-template');
                    set_active_switch_layout_button();
                    break;
            }

            $(document).trigger('hh:archive:layout_switched');
        });
    });
});

// Выравнивание блоков "Новое на сайте" и "Вопрос специалисту" по высоте
jQuery(document).on('hh:homepage:new_on_site_flatted', function (event, height) {
    const hh_question_to_priest__height = $('.hh-question-to-priest').outerHeight();

    if (height && hh_question_to_priest__height <= height) {

        const block_for_flatting = $('.hh-question-to-priest__slider-col');
        const block_for_flatting__padding_bottom = parseInt(block_for_flatting.css('padding-bottom'));

        block_for_flatting.css('padding-bottom', block_for_flatting__padding_bottom + height - hh_question_to_priest__height + 'px');
    }
});

// Переключаем фокус курсора на поле поиска в дополнительном окне поиска
$('#hh-search-overlay').on('hh:overlay:is_showed', () => {
    $('.hh-search-overlay__input').focus();
});

// Регистрация события счетчиков - переход на страницу donate
$(document).ready(() => {
    $('a[href*="/donate/"]').on('click', function () {
        hh_send_counter_target('donate_link_click');
    })
});

// Регистрация события появления на экране блока "Поскольку вы здесь"
let blockDonationv10IsShowing = false;

$(window).scroll(() => {
    if (! document.querySelector('.hh-donation-block-v10')) {
        return false;
    }

    if (!blockDonationv10IsShowing) {
        $('.hh-donation-block-v10').each((index, element) => {
            helpers.elementIsShow(element)
                .then(() => {
                    hh_send_counter_target('monetary_hh-donation-block-v10_show');
                    blockDonationv10IsShowing = true;
                    console.log('Element donation block is showing');
                })
        });

    }
});